import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Col, Row } from "../../components/Component";
import RecentOrders from "../../components/partials/default/recent-orders/RecentOrders";
import { useLocation, useNavigate } from "react-router";
import useLogout from "../../hooks/useLogout";
import { useForm } from "react-hook-form";
import { getDashboardOrdersAPI } from "../../api/order";
import { toast } from "react-toastify";

const AllOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(25);
  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: true,
      topProductLoading: true,
      tableLoading: true,
      orderData: [],
      salesData: [],
      orders: [],
      customerData: [],
      storeStats: [],
      topProducts: [],
      limit: 4,

      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [onSearch, setonSearch] = useState(false);
  const [onSearchText, setSearchText] = useState("");
  const orderData = watch("orderData");
  const limit = watch("limit");
  const tableLoading = watch("tableLoading");
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(onSearchText);
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler);
    };
  }, [onSearchText]);
  useEffect(() => {
    const body = {
      search: debouncedSearch,
      page: currentPage,
      limit: itemPerPage,
    };

    getOrders(body);
  }, [debouncedSearch, currentPage, itemPerPage]);
  const getOrders = (body) => {
    getDashboardOrdersAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("limit", res.data.data?.totalOrders);
          setValue("orderData", res.data.data);
          setValue("tableLoading", false);
        } else if (res.data.status === false) {
          setValue("tableLoading", false);
          setValue("cityDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("tableLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("tableLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const onOrderClick = (item) => {
    const body = {
      order_id: item?.orderNum,
    };
    navigate("/order-details", { state: body });
  };
  return (
    <>
      <Head title="Orders" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Order List</BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className={`g-gs`}>
            <Col>
              <RecentOrders
              title={"Orders"}
                setSearchText={setSearchText}
                onSearchText={onSearchText}
                onSearch={onSearch}
                setonSearch={setonSearch}
                data={orderData?.orders}
                limit={limit}
                setItemPerPage={setItemPerPage}
                itemPerPage={itemPerPage}
                paginate={paginate}
                currentPage={currentPage}
                isLoading={tableLoading}
                onOrderClick={onOrderClick}
                pagination
              />
            </Col>
          </Row>
        </Block>
      </Content>
    </>
  );
};

export default AllOrder;
